import { notifications } from '@mantine/notifications';

import { API_DOMAIN } from './const';

async function handleResponse(response) {
    if (!response.ok) {
        throw response;
    }

    return response.headers.get('content-type')?.includes('application/json') ? response.json() : response;
}

async function fetcher(url, opts) {
    return fetch(url, {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        ...opts,
    }).then(handleResponse)
        .then((response) => response)
        .catch((error) => {
            notifications.show({
                title: `Ошибка ${error.status || ''}`,
                message: error.statusText,
                color: 'red',
            });

            return Promise.reject(error);
        });
}

// eslint-disable-next-line import/prefer-default-export
export function apiFetcher(url, opts) {
    return fetcher(`${API_DOMAIN}${url}`, opts);
}
